export interface StandardContent {
  title: string;
  subtitle?: string;
  description: string;
  howItWorks?: { icon: string; text: string }[];
  requirements?: { icon: string; text: string }[];
  priceLabel?: string;
  price?: string;
}

export const STANDARD_CONTENTS: { [key: string]: StandardContent } = {
  transfer: {
    title: 'transfer',
    subtitle: 'to-consult',
    description:
      'transfer-description',
    priceLabel: 'Precio del servicio',
    howItWorks: [
      {
        icon: 'calender-icon',
        text: 'how-does-it-work-text-1',
      },
      {
        icon: 'driver-icon',
        text: 'how-does-it-work-text-2',
      },
      {
        icon: 'location-icon',
        text: 'how-does-it-work-text-3',
      },
    ],
    requirements: [
      {
        icon: 'document-ok-icon',
        text: 'requirements-for-solicitude-text-1',
      },
      {
        icon: 'document-text-icon',
        text: 'requirements-for-solicitude-text-2',
      },
      {
        icon: 'document-insurance-icon',
        text: 'requirements-for-solicitude-text-3',
      },
      {
        icon: 'refuel-icon',
        text: 'requirements-for-solicitude-text-4',
      },
    ],
  },
  'valet-station': {
    title: 'valet',
    subtitle: 'to-consult',
    description: 'valet-description',
    howItWorks: [
      {
        icon: 'calender-icon',
        text: 'how-does-it-work-text-1',
      },
      {
        icon: 'driver-icon',
        text: 'valet-how-does-it-works-text-1',
      },
      {
        icon: 'center-icon',
        text: 'valet-how-does-it-works-text-2',
      },
      {
        icon: 'extras-icon',
        text: 'valet-how-does-it-works-text-3',
      },
      {
        icon: 'location-icon',
        text: 'valet-how-does-it-works-text-4',
      },
    ],
    requirements: [
      {
        icon: 'document-ok-icon',
        text: 'requirements-for-solicitude-text-1',
      },
      {
        icon: 'document-text-icon',
        text: 'requirements-for-solicitude-text-2',
      },
      {
        icon: 'document-insurance-icon',
        text: 'requirements-for-solicitude-text-3',
      },
      {
        icon: 'refuel-icon',
        text: 'requirements-for-solicitude-text-4',
      },
    ],
    priceLabel: 'Precio del servicio',
    price: '23,50€',
  }
};
